import { NewsletterSignUp } from '@/components/NewsletterSignUp/NewsletterSignUp'
import { Document } from '@contentful/rich-text-types'
import { GlobalProps } from 'src/utils/globalProps'
import { useContext, JSX } from 'react'

export interface NewsletterModuleProps {
  active?: boolean
  title?: string
  text?: Document
  firstName?: string
  lastName?: string
  email?: string
  ctaButton?: string
  submittedFormTitle?: string
  submittedFormText?: string
  errorMessage?: string
  requiredFirstnameText?: string
  requiredLastnameText?: string
  requiredEmailText?: string
  invalidEmailText?: string
  reCaptchaClientKey?: string
}

export const NewsLetterModule = (props: NewsletterModuleProps): JSX.Element => {
  const { contentfulLocale } = useContext(GlobalProps)
  return <NewsletterSignUp locale={contentfulLocale} {...props} />
}
